var map = {
	"./About": [
		8317,
		9
	],
	"./About.css": [
		9691,
		9
	],
	"./About.js": [
		8317,
		9
	],
	"./reviews/reviews0": [
		1020,
		3,
		20
	],
	"./reviews/reviews0.json": [
		1020,
		3,
		20
	],
	"./reviews/reviews1": [
		2533,
		3,
		533
	],
	"./reviews/reviews1.json": [
		2533,
		3,
		533
	],
	"./reviews/reviews10": [
		379,
		3,
		379
	],
	"./reviews/reviews10.json": [
		379,
		3,
		379
	],
	"./reviews/reviews11": [
		7435,
		3,
		435
	],
	"./reviews/reviews11.json": [
		7435,
		3,
		435
	],
	"./reviews/reviews12": [
		2268,
		3,
		268
	],
	"./reviews/reviews12.json": [
		2268,
		3,
		268
	],
	"./reviews/reviews13": [
		4028,
		3,
		28
	],
	"./reviews/reviews13.json": [
		4028,
		3,
		28
	],
	"./reviews/reviews14": [
		7740,
		3,
		740
	],
	"./reviews/reviews14.json": [
		7740,
		3,
		740
	],
	"./reviews/reviews15": [
		3775,
		3,
		775
	],
	"./reviews/reviews15.json": [
		3775,
		3,
		775
	],
	"./reviews/reviews16": [
		4765,
		3,
		765
	],
	"./reviews/reviews16.json": [
		4765,
		3,
		765
	],
	"./reviews/reviews17": [
		6358,
		3,
		358
	],
	"./reviews/reviews17.json": [
		6358,
		3,
		358
	],
	"./reviews/reviews18": [
		3778,
		3,
		778
	],
	"./reviews/reviews18.json": [
		3778,
		3,
		778
	],
	"./reviews/reviews19": [
		7731,
		3,
		731
	],
	"./reviews/reviews19.json": [
		7731,
		3,
		731
	],
	"./reviews/reviews3": [
		460,
		3,
		460
	],
	"./reviews/reviews3.json": [
		460,
		3,
		460
	],
	"./reviews/reviews4": [
		5638,
		3,
		638
	],
	"./reviews/reviews4.json": [
		5638,
		3,
		638
	],
	"./reviews/reviews5": [
		3981,
		3,
		981
	],
	"./reviews/reviews5.json": [
		3981,
		3,
		981
	],
	"./reviews/reviews6": [
		6763,
		3,
		763
	],
	"./reviews/reviews6.json": [
		6763,
		3,
		763
	],
	"./reviews/reviews7": [
		5871,
		3,
		871
	],
	"./reviews/reviews7.json": [
		5871,
		3,
		871
	],
	"./reviews/reviews8": [
		8704,
		3,
		704
	],
	"./reviews/reviews8.json": [
		8704,
		3,
		704
	],
	"./reviews/reviews9": [
		4914,
		3,
		914
	],
	"./reviews/reviews9.json": [
		4914,
		3,
		914
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 738;
module.exports = webpackAsyncContext;